import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  data: function data() {
    return {
      initialPageYOffset: 0
    };
  },
  methods: {
    handleScroll: function handleScroll() {
      window.scrollTo(0, this.initialPageYOffset);
    },
    disableWindowScroll: function disableWindowScroll() {
      if (this.isMobile()) {
        window.document.querySelector('body').style.overflow = 'hidden';
        return;
      }

      this.initialPageYOffset = window.pageYOffset;
      window.addEventListener('scroll', this.handleScroll, false);
    },
    enableWindowScroll: function enableWindowScroll() {
      window.document.querySelector('body').style.overflow = '';
      window.removeEventListener('scroll', this.handleScroll, false);
    }
  }
};